// 代发管理订单G
const map = {
  orderList: () => import('@/views/undertakes/OrderList'),
  aftersingleList: () => import('@/views/undertakes/AftersingleList'),
  aftersingleDetail: () => import('@/views/undertakes/AftersingleDetail'),
  billList: () => import('@/views/undertakes/BillList'),
  prototypeList1: () => import('@/views/stock/PrototypeList'),
  prototypeOrderList1: () => import('@/views/stock/PrototypeOrderList'),
  prototypeOrderDetail1: () => import('@/views/stock/PrototypeOrderDetail')
}

export default map
